import {Injectable} from '@angular/core';
import {EventListVO, EventVO} from './event.interfaces';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {CrudEffects} from '@abydos-angular/store';
import {eventDefinition} from './event.reducers';
import {EventRepository} from './event.repository';

@Injectable()
export class EventEffects extends CrudEffects<EventVO, EventListVO> {

    /*
      Minta Effect
      SampleEffect = createEffect(() => this.actions.pipe(
        ofType({{action_type}}),
        switchMap(() => {
          return this.crudRepository.fgv().pipe(
            map((payload) => {
              return {payload: payload};
            })
            , toActionCreatorPayload(result_action, HandleErrorAction)
          );
        })
      )
    );
    */
    constructor(actions: Actions, private eventRepository: EventRepository) {
        super(actions, eventRepository, eventDefinition);
    }
}
